module.exports = __webpack_public_path__ + "static/media/graphic-library-small.395bce22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/graphic-library-small.svg
// module id = 185
// module chunks = 0